import { useState } from "react";
import dayjs from "dayjs";
import { Pagination } from "components/molecules";
import { SelfPacedHomeWorkRow } from "components/molecules/SelfPacedHomeWorkRow";
import { formatToLocalDate } from "utils/functions/formatToLocalDate";
import { getRowDisplayForWork } from "utils/functions/drillSmart";
import "./index.scss";
import { CONTENT_OBJECT_TYPE_ID } from "utils/constants";

interface IProps {
  exams: any;
  type: any;
  theme: "light" | "dark";
  settoggleUnlockModal?: any;
  handlePrimaryBtnClick: any;
  handleSecondaryBtnClick: any;
}

export const DrillPaginationTab = ({
  exams,
  type,
  theme,
  settoggleUnlockModal,
  handlePrimaryBtnClick,
  handleSecondaryBtnClick,
}: IProps) => {
  const [drillPage, setDrillPage] = useState(1);

  return (
    <>
      {[...exams]
        .slice((drillPage - 1) * 5, drillPage * 5)
        .map((value: any, index: number) => {
          const rowDisplay = getRowDisplayForWork(value, {
            formatDateCompleted: (d) => formatToLocalDate(d, "MM/DD/YYYY"),
            treatAsDrillSmart: type === "DrillSmartContent",
            contentObjectTypeResolver: (w) =>
              w.hasOwnProperty("ContentObjectTypeId")
                ? (Object.keys(CONTENT_OBJECT_TYPE_ID).find(
                    (key: string) =>
                      CONTENT_OBJECT_TYPE_ID[key] === w.ContentObjectTypeId
                  ) ?? w.ContentObjectType)
                : w.ContentObjectType,
          });
          return (
            <div className="self-paced-courseowrk-class-container" key={index}>
              <SelfPacedHomeWorkRow
                index={index}
                textIconLabel={rowDisplay.textIconLabel}
                badge={rowDisplay.badge}
                iconType={rowDisplay.iconType}
                middleLabel={rowDisplay.middleLabel}
                handlePrimaryBtnClick={() => handlePrimaryBtnClick(value, type)}
                handleSecondaryBtnClick={() => handleSecondaryBtnClick(value)}
                status={rowDisplay.status}
                isLocked={rowDisplay.isDrillSmart ? false : value.IsLocked}
                contentObjectType={rowDisplay.contentObjectType}
                drillSmartResult={rowDisplay.drillSmartResult}
                theme={theme}
              />
            </div>
          );
        })}
      <div className="self-paced-courseowrk-pagination-container">
        <Pagination
          pages={exams.length}
          currentPage={drillPage}
          setCurrentPage={setDrillPage}
          theme={theme}
        />
      </div>
    </>
  );
};
